import axios from 'axios'

const apiBase = axios.create({
    baseURL: "http://localhost:8080"
})

const awsBase = axios.create({
    baseURL: "https://vrp2m0bhr4.execute-api.us-east-1.amazonaws.com/Prod"
})

export const CalculateResponse = {
    EP: (data) => {
        return apiBase.post(`/ep/response`, data)
    },
    TP: (data) => {
        return apiBase.post(`/tp/response`, data)
    },
    NP: (data) => {
        return apiBase.post(`/np/response`, data)
    },
    IR: (data) => {
        return apiBase.post(`/ir/response`, data)
    },
    DM: (data) => {
        return apiBase.post(`/dm/response`, data)
    },
    DMB: (data) => {
        return apiBase.post(`/dmb/response`, data)
    },
    PM: (data) => {
        return apiBase.post(`/pm/response`, data)
    }
}

export const CallCalibrate = {
    EP: (data) => {
        return apiBase.post(`/ep/calibrate`, data)
    },
    TP: (data) => {
        return apiBase.post(`/tp/calibrate`, data)
    },
    NP: (data) => {
        return apiBase.post(`/np/calibrate`, data)
    },
    IR: (data) => {
        return apiBase.post(`/ir/calibrate`, data)
    },
    DM: (data) => {
        return apiBase.post(`/dm/calibrate`, data)
    },
    DMB: (data) => {
        return apiBase.post(`/dmb/calibrate`, data)
    },
    PM: (data) => {
        return apiBase.post(`/pm/calibrate`, data)
    },
    MS_DM: (data) => {
        return awsBase.post(`/MS/DM/Calibrate`, data)
    }
}

export const CallPredict = {
    EP: (data) => {
        return apiBase.post(`/ep/predict`, data)
    },
    TP: (data) => {
        return apiBase.post(`/tp/predict`, data)
    },
    NP: (data) => {
        return apiBase.post(`/np/predict`, data)
    },
    IR: (data) => {
        return apiBase.post(`/ir/predict`, data)
    },
    DM: (data) => {
        return apiBase.post(`/dm/predict`, data)
    },
    DMB: (data) => {
        return apiBase.post(`/dmb/predict`, data)
    },
    PM: (data) => {
        return apiBase.post(`/pm/predict`, data)
    }
}

export const CallUtil = {
    Spline: (data) => {
        return awsBase.post(`/util/spline/value`, data)
    }
}